import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderRemoteCollaboration } from '../../../../hooks/order/useOrderRemoteCollaboration';
import { useOrderContext } from '../../../../providers/OrderProvider';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const AcceptModal = ({ setIsOpenPendingModal, isOpenPendingModal, acceptPendingStat = 'total' }) => {
	const { order, isLoading } = useOrderContext();
	const { handleRemoteOrderUpdate } = useOrderRemoteCollaboration('accept', {
		enabled: isOpenPendingModal,
	});
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
	}, [setIsOpenPendingModal]);

	// 订单总计：物流轨（待验收）；应收账款/准应收子统计：收款轨（与列表视角一致）
	const badgeTrack = acceptPendingStat === 'total' ? 'delivery' : 'payment';
	const acceptStatusBadge = useMemo(() => {
		const badges = order?.uiHints?.modalStatusBadges;
		if (!badges) return null;
		return badgeTrack === 'delivery' ? badges.delivery : badges.payment;
	}, [order, badgeTrack]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={acceptStatusBadge ? [acceptStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				<OrderDetailModalBody
					pendingFocus='accept'
					notesType='accept'
					paymentScheduleModelName='AcceptModal'
					contractTooltipId='accept-contract-toggle-tooltip'
					invoiceTooltipId='accept-invoice-toggle-tooltip'
				/>
			</OrderFullscreenModalBody>
			<OrderModalFooter onRemoteOrderUpdate={handleRemoteOrderUpdate} />
		</OrderFullscreenModal>
	);
};

AcceptModal.propTypes = {
	setIsOpenPendingModal: PropTypes.func.isRequired,
	isOpenPendingModal: PropTypes.bool.isRequired,
	acceptPendingStat: PropTypes.oneOf(['total', 'accountsReceivable', 'quasiReceivable']),
};

export default AcceptModal;
